import { CommonServiceIds } from 'azure-devops-extension-api'

import { getAzureService } from '@/utils/azure-devops-helpers/azure-service'

export const getAzureHistory = async () => {
  return await getAzureService(CommonServiceIds.HostNavigationService)
}

const NO_LOCATION = null

/**
 * Resolves the current host page URL (dev.azure.com/{org}/{project}/_apps/hub/...).
 * The Vue route lives in its hash, same as in the Forge app.
 * `routeUrl` appends routeValues missing from the route template as query params,
 * so they are stripped by default.
 * @param {object} [options={}]
 * @param {boolean} [options.clearSearchParams=true]
 * @returns {Promise<string | null>}
 */
export const getAzureExtensionLocation = async ({ clearSearchParams = true } = {}) => {
  const navigationService = await getAzureHistory()

  if (!navigationService) return NO_LOCATION

  const locationService = await getAzureService(CommonServiceIds.LocationService)

  if (!locationService) return NO_LOCATION

  const { id, routeValues } = await navigationService.getPageRoute()

  const url = new URL(await locationService.routeUrl(id, routeValues))

  if (clearSearchParams) {
    url.search = ''
  }

  return url.toString()
}

export const dispatchUrlByAzureNavService = async url => {
  if (!url) {
    console.warn('No URL provided to dispatch')
    return
  }
  const navService = await getAzureService(CommonServiceIds.HostNavigationService)
  if (!navService) {
    console.warn('Azure history service not found')
    return
  }

  navService.openNewWindow(url, '')
}
